/** Dependencies */
import React from 'react';
import { Outlet } from 'react-router-dom';

function EndOfDayDetails() {
  return <Outlet />;
}

export default EndOfDayDetails;
